import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { CertificateOfInsurance } from '@/modules/CertificateOfInsurance/interfaces/certificate-of-insurance'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import CertificateOfInsuranceForm from '@/modules/CertificateOfInsurance/components/COIForm.vue'
import { deleteCertificateOfInsurance } from '@/modules/CertificateOfInsurance/gql/certificate.gql'

@Component({
  components: {
    CertificateOfInsuranceForm,
    AppDialog
  }
})
export default class CertificateOfInsuranceDialog extends Vue {
  targetCertificateOfInsurance: CertificateOfInsurance | null = null

  certificateDialog = {
    actionType: 'new',
    show: false,
    title: 'New Certificate Of Insurance',
    disable: false
  }

  deleteCertificateDialog = {
    show: false,
    title: 'Delete CertificateOfInsurance',
    text: ''
  }

  showCertificateEditDialog (e: Event, targetCertificateOfInsurance?: CertificateOfInsurance) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Certificate Of Insurance'
    if (targetCertificateOfInsurance) {
      this.targetCertificateOfInsurance = targetCertificateOfInsurance
      actionType = 'edit'
      title = 'Edit Certificate Of Insurance'
    }
    this.certificateDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideCertificateEditDialog () {
    this.targetCertificateOfInsurance = null
    this.certificateDialog = {
      actionType: 'new',
      show: false,
      title: 'New Certificate Of Insurance',
      disable: false
    }
  }

  async deleteCertificateOfInsurance (e: Event, certificate: CertificateOfInsurance) {
    e.preventDefault()
    e.stopPropagation()
    this.targetCertificateOfInsurance = certificate
    this.deleteCertificateDialog.show = true
  }

  async deleteCertificatePost () {
    if (!this.targetCertificateOfInsurance) {
      return
    }
    const { id } = this.targetCertificateOfInsurance
    this.deleteCertificateDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteCertificateOfInsurance,
        variables: {
          coiId: Number(id)
        }
      })

      const res = result.data.deleteCertificateOfInsurance
      if (res) {
        showNotification({
          msg: 'Delete certificate successfully',
          type: SnackType.Success
        })
        this.targetCertificateOfInsurance = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
